const e = {
  add: "Lägg till",
  cancel: "Avbryt",
  clear: "Rensa",
  confirm: "Bekräfta",
  delete: "Radera",
  redo: "Gör om",
  save: "Spara",
  saveAs: "Spara som",
  undo: "Ångra"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, t = {
  cancel: "Avbryt",
  confirm: "Bekräfta",
  datePlaceholder: "Välj datum",
  datetimePlaceholder: "Välj datum och tid",
  endDatePlaceholder: "Slutdatum",
  endDatetimePlaceholder: "Slutdatum och tid",
  endMonthPlaceholder: "Slutmånad",
  monthPlaceholder: "Välj månad",
  now: "Nu",
  quarterPlaceholder: "Välj kvartal",
  selectDate: "Välj datum",
  selectTime: "Välj tid",
  startDatePlaceholder: "Startdatum",
  startDatetimePlaceholder: "Startdatum och tid",
  startMonthPlaceholder: "Startmånad",
  today: "Idag",
  weekPlaceholder: "Välj Vecka",
  yearPlaceholder: "Välj år",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Välj"
}, l = {
  clear: "Rensa",
  negativeText: "Avbryt",
  now: "Nu",
  placeholder: "Välj tid",
  positiveText: "OK"
}, o = {
  placeholder: "Ange"
}, n = {
  placeholder: "Ange"
}, d = {
  placeholder: "Börja skriva ..."
}, s = {
  allRows: "Alla rader",
  default: "Standard",
  deleteLayoutDescription: "Är du säker på att du vill ta bort den här layouten?",
  discardChanges: "Kassera ändringar",
  discardLayoutChanges: "Kassera layoutändringar",
  enterLayoutName: "Ange layoutnamn",
  enterRowNumber: "Ange antal rader",
  fieldsSelected: "fält markerade",
  freezeColumnDescription: "Frys kolumnen till vänster",
  freezeUptoColumn: "Frys upp till kolumn",
  frozen: "Fryst",
  layoutName: "Layoutnamn",
  manageColumns: "Hantera kolumner",
  none: "Ingen",
  reorderRows: "Ändra ordning på rader",
  rowsSelected: "rader markerade",
  saveLayoutAs: "Spara layout som",
  saveLayoutNew: "Spara ny layout",
  search: "Sök",
  searchColumnsPlaceholder: "Sök kolumner",
  searchFieldsPlaceholder: "Sökfält",
  selectAll: "Markera alla",
  setTableHeight: "Ställ in tabellhöjd",
  unfreeze: "Sluta frysa",
  unsavedChanges: "Du har ändringar som inte har sparats",
  unsavedChangesDescription: "Det kan finnas en eller flera osparade ändringar. Vill du spara dem?"
}, c = {
  at: "vid",
  colorAlreadyUsed: "Välj en annan nyans eller använd befintlig",
  colorNamePlaceholder: "Ange namn",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Välj ett annat färgnamn",
  noColorsAdded: "Du har inga färger i den här sektionen."
}, i = {
  searchPlaceholder: "Sök"
}, p = {
  invalidPastedData: "Ogiltiga inklistrade data"
}, u = {
  of: "av",
  page: "Sida",
  rowsPerPage: "Rader per sida"
}, m = {
  failedToUpload: "Det gick inte att ladda upp",
  retry: "Försök igen",
  clickToUpload: "klicka för att ladda upp",
  orDragAndDrop: "Eller Dra och släpp",
  supportedFileTypes: "Filtyper som stöds:"
}, h = {
  global: e,
  Progress: a,
  DatePicker: t,
  Select: r,
  TimePicker: l,
  Input: o,
  InputNumber: n,
  InputTag: d,
  HLDataTable: s,
  ColorPicker: c,
  InputPhone: i,
  InputOtp: p,
  Pagination: u,
  Upload: m
};
export {
  c as ColorPicker,
  t as DatePicker,
  s as HLDataTable,
  o as Input,
  n as InputNumber,
  p as InputOtp,
  i as InputPhone,
  d as InputTag,
  u as Pagination,
  a as Progress,
  r as Select,
  l as TimePicker,
  m as Upload,
  h as default,
  e as global
};
